// Random app-install identifier used only where the app needs a stable,
// non-content identifier (for example optional analytics or AI abuse limits).
// It is not derived from hardware, advertising IDs, email, or private writing.

const ID_KEY = "un_install_id_v1";

const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Callers can still use the generated in-memory value for this request.
  }
};

let fallbackId = null;

export const getInstallId = () => {
  const saved = safeGet(ID_KEY);
  if (saved) return saved;
  if (fallbackId) return fallbackId;

  fallbackId =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random()
          .toString(36)
          .slice(2)}`;
  safeSet(ID_KEY, fallbackId);
  return fallbackId;
};
